import { Component, HostBinding } from '@angular/core';
import { Observable } from 'rxjs';
import { AuthorizationService } from '../../authorization/authorization.service';

@Component({
  selector: 'app-header',
  template: `
    @if (isAuthenticated$ | async) {
      <app-authenticated-header>auth header</app-authenticated-header>
    }
    @if ((isAuthenticated$ | async) === false) {
      <app-unauthenticated-header>unauth header</app-unauthenticated-header>
    }
  `,
})
export class HeaderComponent {
  public isAuthenticated$: Observable<boolean>;
  @HostBinding('class.site-header') header = true;

  constructor(_authorizationService: AuthorizationService) {
    this.isAuthenticated$ = _authorizationService.isAuthenticated$;
  }
}
